import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-top1",
  "use": "icon-top1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-top1\">\r\n<path d=\"M897.4,68.5H126.6c-32.1,0-58.1,26-58.1,58.1v770.8c0,32.1,26,58.2,58.1,58.2h770.8c32.1,0,58.1-26,58.1-58.2V126.6\r\n\tC955.5,94.5,929.5,68.5,897.4,68.5z M622.9,583.9v202.4H400.5l1.3-201.8H257.1L512,338.2L771.3,582L622.9,583.9z M786.3,318.6H237.7\r\n\tv-80.9h548.6V318.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol